/* esm.sh - @radix-ui/react-dialog@1.1.15 */
export * from "/*@radix-ui/react-dialog@1.1.15/esnext/react-dialog.mjs";
